import { IS_ACTIVE } from '../constants';

// Testimonials slider
class TestimonialsSlider {
    private slider: HTMLDivElement | null;
    private sliderNav: HTMLDivElement | null;
    private sliderNavItems: NodeListOf<HTMLSpanElement> | undefined;
    private sliderItems: HTMLDivElement | null;
    private slides: NodeListOf<HTMLDivElement> | undefined;
    private slidesLength: number;
    private slideSize: number;
    private sliderInterval: number = 10000;
    private index: number = 0;
    private allowShift: boolean = true;
    private interval: ReturnType<typeof setInterval>;

    constructor(testimonialsSlider: HTMLDivElement) {
        this.slider = testimonialsSlider;
        this.sliderNav = this.slider.querySelector<HTMLDivElement>('.js-testimonials__nav');
        this.sliderNavItems = this.sliderNav?.querySelectorAll<HTMLSpanElement>('.js-testimonials__nav-item');
        this.sliderItems = this.slider.querySelector<HTMLDivElement>('.js-testimonials__slides');
        this.slides = this.sliderItems?.querySelectorAll<HTMLDivElement>('.js-testimonial');

        if (!this.slides) {
            return;
        }

        this.slidesLength = this.slides.length;
        this.slideSize = this.slides[0].offsetWidth + 60;
        this.sliderItems?.addEventListener('transitionend', () => {
            this.checkIndex();
        });
        this.interval = setInterval(() => {
            return this.shiftSlide(this.index);
        }, this.sliderInterval);

        this.attachSliderNavigationEvents(this.sliderNavItems);
    }

    private shiftSlide(slideIndex: number, increaseIndex: boolean = true): void {
        let positionLeft: number;

        if (!this.sliderItems) {
            return;
        }

        this.sliderItems.classList.add('shifting');
        this.index = slideIndex;

        if (this.allowShift) {
            if (increaseIndex) {
                this.index++;
            }

            if (this.slidesLength === this.index || this.index === 0) {
                positionLeft = 0;
            } else {
                positionLeft = this.index * this.slideSize;
            }

            this.sliderItems.style.left = `-${positionLeft}px`;
        }

        this.allowShift = false;
    }

    private checkIndex(): void {
        if (this.index === 0) {
            this.index = this.slidesLength;
        } else if (this.index === this.slidesLength + 1) {
            this.index = 1;
        }

        if (!this.sliderItems) {
            return;
        }

        this.sliderItems.classList.remove('shifting');

        if (this.index === -1) {
            this.sliderItems.style.left = '0';
            this.index = this.slidesLength - 1;
        }

        if (this.index === this.slidesLength) {
            this.sliderItems.style.left = '0';
            this.index = 0;
        }

        this.setActiveSliderNavItem(this.sliderNavItems, this.index);
        this.allowShift = true;
    }

    private setActiveSliderNavItem(navigationItems: NodeListOf<HTMLSpanElement> | undefined, itemIndex: number): void {
        if (!navigationItems) {
            return;
        }

        navigationItems.forEach((item: HTMLSpanElement) => {
            item.classList.remove(IS_ACTIVE);
        });

        navigationItems[itemIndex].classList.add(IS_ACTIVE);
    }

    private attachSliderNavigationEvents(sliderNavItems: NodeListOf<HTMLSpanElement> | undefined): void {
        sliderNavItems?.forEach((sliderNavItem: HTMLSpanElement) => {
            sliderNavItem.addEventListener('click', (e: Event) => {
                e.preventDefault();

                this.removeActiveClass(this.sliderNavItems);
                sliderNavItem.classList.add(IS_ACTIVE);

                if (this.interval) {
                    clearInterval(this.interval);
                }

                this.shiftSlide(Array.from(sliderNavItems).indexOf(sliderNavItem), false);

                return (this.interval = setInterval(() => {
                    return this.shiftSlide(this.index);
                }, this.sliderInterval));
            });
        });
    }

    private removeActiveClass = (elements: NodeListOf<HTMLElement> | undefined): void => {
        elements?.forEach((element: HTMLDivElement) => {
            element.classList.remove(IS_ACTIVE);
        });
    };
}

export default TestimonialsSlider;
